import { identity } from "lodash";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import {
  DEFAULT_BUTTON_DATA,
  DEFAULT_CODE_DATA,
  DEFAULT_DIVIDER_DATA,
  DEFAULT_HEADING_DATA,
  DEFAULT_HTML_DATA,
  DEFAULT_MAP_DATA,
  DEFAULT_PARAGRAPH_DATA,
  DEFAULT_POLL_DATA
} from "./node-builder-methods";
const setupAbstractContentBuilder = (generateId, textNodeCreator, listNodeCreator, nodeCreator, tableNodeCreator, collapsibleListNodeCreator, methodPrefix = identity) => {
  class RicosContentBuilder {
  }
  const builderApis = {};
  const addMethod = (name, method) => {
    builderApis[methodPrefix(name)] = RicosContentBuilder.prototype[methodPrefix(name)] = method;
  };
  const TextNodes = [
    {
      name: "paragraph",
      type: Node_Type.PARAGRAPH,
      dataT: DEFAULT_PARAGRAPH_DATA
    },
    { name: "heading", type: Node_Type.HEADING, dataT: DEFAULT_HEADING_DATA },
    { name: "code", type: Node_Type.CODE_BLOCK, dataT: DEFAULT_CODE_DATA }
  ];
  const ListNodes = [
    { name: "bulletList", type: Node_Type.BULLETED_LIST },
    { name: "orderedList", type: Node_Type.ORDERED_LIST }
  ];
  const PluginNodes = [
    { name: "divider", type: Node_Type.DIVIDER, dataT: DEFAULT_DIVIDER_DATA },
    { name: "file", type: Node_Type.FILE, dataT: {} },
    { name: "gallery", type: Node_Type.GALLERY, dataT: {} },
    { name: "html", type: Node_Type.HTML, dataT: DEFAULT_HTML_DATA },
    { name: "image", type: Node_Type.IMAGE, dataT: {} },
    { name: "video", type: Node_Type.VIDEO, dataT: {} },
    { name: "appEmbed", type: Node_Type.APP_EMBED, dataT: {} },
    { name: "embed", type: Node_Type.EMBED, dataT: {} },
    {
      name: "linkPreview",
      type: Node_Type.LINK_PREVIEW,
      dataT: {}
    },
    { name: "button", type: Node_Type.BUTTON, dataT: DEFAULT_BUTTON_DATA },
    { name: "gif", type: Node_Type.GIF, dataT: {} },
    { name: "map", type: Node_Type.MAP, dataT: DEFAULT_MAP_DATA },
    { name: "poll", type: Node_Type.POLL, dataT: DEFAULT_POLL_DATA }
  ];
  TextNodes.forEach(
    ({
      name,
      type,
      dataT
    }) => {
      addMethod(name, ({ data = dataT, text, ...rest }) => {
        return textNodeCreator(generateId)({
          text,
          type,
          data,
          ...rest
        });
      });
    }
  );
  ListNodes.forEach(({ name, type }) => {
    addMethod(name, ({ items, data, ...rest }) => {
      return listNodeCreator(generateId)({ items, data, type, ...rest });
    });
  });
  PluginNodes.forEach(({ name, type, dataT }) => {
    addMethod(name, ({ data = dataT, ...rest }) => {
      return nodeCreator(generateId)({
        type,
        data,
        ...rest
      });
    });
  });
  Object.entries({
    table: tableNodeCreator,
    collapsibleList: collapsibleListNodeCreator
  }).forEach(([name, method]) => addMethod(name, method(generateId)));
  return builderApis;
};
export {
  setupAbstractContentBuilder
};
//# sourceMappingURL=AbstractContentBuilder.js.map
